<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="sub-section">
	<div class="sub-section-header">
		<span class="sub-section-title">2. Configuration</span>

		<span class="sub-section-description">
			Complete all the elements of the first column and at least the details of one hardware
			component in the other columns to be able to proceed with the calculation.
		</span>
	</div>

	<div class="card-list">
		@for (hardwareComponent of hardwareComponents; track hardwareComponent.id) {
			<form
				[formGroup]="hardwareComponent.form"
				class="card"
			>
				<globalictcc-input
					label="Manufacturer Part Number"
					formControlName="manufacturerPartNumber"
				/>

				<globalictcc-dropdown
					label="Manufacturer"
					formControlName="manufacturer"
					[options]="manufacturersOptions"
					[allowSearch]="true"
				/>

				<globalictcc-dropdown
					label="General category"
					formControlName="generalCategory"
					[options]="generalCategoriesOptions"
					(handleSelectionChange)="onGeneralCategoryChange($event, hardwareComponent)"
					[allowSearch]="true"
				/>

				<globalictcc-dropdown
					label="Specific category"
					formControlName="category"
					[options]="hardwareComponent.categoriesOptions"
					[allowSearch]="true"
				/>

				<globalictcc-dropdown
					label="Location"
					formControlName="location"
					[options]="locationsOptions"
					[allowSearch]="true"
				/>

				<globalictcc-input
					label="Parts count"
					formControlName="partsCount"
					inputType="number"
					[acceptFloat]="false"
				/>

				<globalictcc-button
					[textOnly]="true"
					iconName="delete"
					[disabled]="hardwareComponents.length <= 1"
					(handleClick)="onRemoveHardwareComponent(hardwareComponent.id)"
				/>
			</form>
		}
	</div>

	<globalictcc-button
		label="Add another hardware component"
		[textOnly]="true"
		iconName="plus"
		(handleClick)="onAddHardwareComponent()"
	/>

	<globalictcc-button
		label="Calculate"
		[disabled]="isCalculationDisabled()"
		(handleClick)="onCalculate()"
	/>
</section>

@if (isLoading) {
	<div class="loading">
		<globalictcc-spinner />

		<span class="message">Loading...</span>
	</div>
} @else {
	@if (hasError) {
		<div class="error">
			<div class="error-message">
				<span class="icon-unlink"></span>

				<span class="message">
					There are some errors in the the calculation, please check the error log.
				</span>

				<button
					class="error-log-toggle"
					(click)="isErrorLogOpened = !isErrorLogOpened"
				>
					Error log

					<span
						class="icon-chevron-down"
						[ngClass]="{ 'is-opened': isErrorLogOpened }"
					></span>
				</button>

				@if (isErrorLogOpened) {
					<span class="error-log">
						{{ errorLogMessage }}
					</span>
				}

				<globalictcc-button
					label="Retry"
					iconName="update"
					[textOnly]="true"
					(handleClick)="onCalculate()"
				/>
			</div>
		</div>
	} @else {
		@if (hasCalculated) {
			<section class="sub-section">
				<div class="sub-section-header">
					<span class="sub-section-title">3. Results</span>

					<span class="sub-section-description">
						Select the uploaded hardware list to compare with each others.
					</span>
				</div>

				<globalictcc-table
					[gridOptions]="emissionGridOptions"
					[hasError]="overviewTableHasError"
					(handleTableRefresh)="onTableRefresh()"
				/>

				<div class="charts">
					<globalictcc-chart
						chartType="pie"
						[data]="emissionByScopePieChart?.chart"
						[isLoading]="isEmissionByScopePieChartLoading"
						[hasError]="emissionByScopePieChart?.hasError"
						labelPosition="outside"
						[configOverrides]="emissionByScopePieChartOverrides()"
						(handleChartRefresh)="onEmissionByScopeChartRefresh()"
					/>

					<globalictcc-chart
						chartType="pie"
						[data]="emissionByModelPieChart?.chart"
						[isLoading]="isEmissionByModelPieChartLoading"
						[hasError]="emissionByModelPieChart?.hasError"
						labelPosition="outside"
						[colors]="totalEmissionPieChartColors"
						[configOverrides]="emissionByManufacturerPieChartOverrides()"
						(handleChartRefresh)="onEmissionByModelChartRefresh()"
					/>
				</div>

				<globalictcc-chart
					chartType="barX"
					[data]="totalEmissionBarChart?.chart"
					[isLoading]="isTotalEmissionBarChartLoading"
					[hasError]="totalEmissionBarChart?.hasError"
					[configOverrides]="totalEmissionBarChartOverrides"
					(handleChartRefresh)="onTotalEmissionChartRefresh()"
				/>
			</section>
		}
	}
}
